var FeaturedArticles = class extends HTMLElement {
  constructor() {
    super();

    this.buttons = this.querySelectorAll('.slider-button');
    this.buttons.forEach(item => {
      item.addEventListener('click', this.handleButtonClick.bind(this));
    });

    this.sliders = this.querySelectorAll('.featured-articles');
    this.sliders.forEach((slider, idx) => {
      this.loadSlider(slider, idx);
    });
  }

  handleButtonClick() {
    const el = event.target;
    const id = el.dataset.id;

    if (el.classList.contains('opacity-50')) {
      this.querySelector('.slider-button').classList.add('opacity-50');
      this.querySelectorAll('.slider-button').forEach(button => {
        if (!button.classList.contains('opacity-50')) button.classList.add('opacity-50');
      });
      el.classList.remove('opacity-50');

      this.querySelectorAll('.featured-articles').forEach(arrows => {
        if (!arrows.classList.contains('hidden')) arrows.classList.add('hidden');
      });
      this.querySelector(`.featured-articles[data-id="${id}"]`).classList.remove('hidden');
    }
  }

  loadSlider(slider) {
    const featuredArticleSlider = new Swiper(slider, {
      slidesPerView: 'auto',
      loop: false,
      watchOverflow: true,
      breakpoints: {
        768: {
          slidesPerView: 3
        }
      }
    });
  }
}

customElements.define('featured-articles', FeaturedArticles);